<div class="card">
    <div class="card-header">
      <h1>Planillas</h1>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="year" class="form-label">Año</label>
        <select name="year" [(ngModel)]="year" (change)="cleanAndGet()" class="form-select" id="year">
          <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
        </select>
        <p class="form-text" style="font-size: 0.8rem; opacity: 0.7;">
          <i class="fa fa-circle-info"></i> Aquí podrá ver las planillas generadas o aún no generadas por mes.
        </p>
      </div>
  
      <hr>
  
      <div class="row">
        <div class="col-md-3" style="padding: 1em;" *ngFor="let m of months">
          <div class="panel erp-panel">
            <div class="panel-heading erp-panel-heading text-center">
              <h5>
                <i class="fa fa-calendar-days" aria-hidden="true"></i> {{ m.name }} {{ year }}
              </h5>
            </div>
            <div class="panel-body erp-panel-body text-center">
  
              <!-- Si existe payroll para este mes -->
              <div *ngIf="m.payroll">
                <p><strong>{{ m.payroll.status }}</strong></p>
                <button class="btn btn-info" style="width: 100%;" (click)="viewPayroll(m.payroll)">
                  <i class="fa fa-eye"></i> Ver Detalles
                </button>
              </div>
  
              <!-- Si NO existe payroll para este mes -->
              <div *ngIf="!m.payroll">
                <i class="fa fa-ban" aria-hidden="true" style="font-size: 2em; color: gray;"></i>
                <p>Aún no hay planilla generada para este mes</p>
                <button class="btn btn-success" (click)="getSummary(m)" [disabled]="generating">
                <i class="fa fa-hammer" *ngIf="!generating"></i>
                <span *ngIf="generating" class="spinner-border spinner-border-sm"></span>
                Generar Planilla
            </button>
              </div>
  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal de Detalle -->
  <app-simple-modal
    *ngIf="payrollSelected"
    [title]="'Detalle de planilla'"
    (close)="payrollSelected = null"
    [max]="90"
    [requiredFields]="false">
    <div fields>
      <div *ngFor="let position of payrollSelected.summary">
        <h6 class="mt-3 text-primary">
          🧾 Puesto: {{ position.positionName }} - Total: {{ position.total | currency: 'Q' }}
        </h6>
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Empleado</th>
              <th>Total del Empleado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let person of position.personal">
              <tr>
                <td>{{ person.employeeName }}</td>
                <td>{{ person.total | currency: 'Q' }}</td>
                <td>
                  <button class="btn btn-sm btn-link" (click)="person.expanded = !person.expanded">
                    {{ person.expanded ? 'Ocultar detalles' : 'Ver pagos' }}
                  </button>
                </td>
              </tr>
              <tr *ngIf="person.expanded">
                <td colspan="3">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>Monto</th>
                        <th>Descripción</th>
                        <th>Tipo de Pago</th>
                        <th>Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let payment of person.payments">
                        <td>{{ payment.amount | currency: 'Q' }}</td>
                        <td>{{ payment.description }}</td>
                        <td>{{ getPayrollTypeText(payment.paymentType) }}</td>
                        <td>{{ getLastDayOfMonthFromMonthNumber(payrollSelectedMonth) | date: 'yyyy/MM/dd' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </app-simple-modal>
  